import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Stand } from 'src/app/entity/Stand';
import { StandService } from 'src/app/service/stand.service';
import { Table } from 'primeng';
declare var jsPDF: any;
  
 
@Component({
  selector: 'app-stands',
  templateUrl: './stands.component.html',
  styleUrls: ['./stands.component.css']
})
export class StandsComponent implements OnInit {
  stands: Stand[];

  selectedStands: Stand[];

  cols: any[];

  exportColumns: any[];
  @Input() index:number;
  constructor(private standService: StandService) { }

  ngOnInit() {
      this.standService.findStandsByProject(1,true).subscribe(stands => this.stands = stands);

      this.cols = [
          { field: 'num', header: 'Stand' },
          { field: 'clientList', header: 'Client' },
          { field: 'superficie', header: 'Superficie' },
          { field: 'standType', header: 'Type' } 
      ];

      this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field }));
  }
  exportPdf() {
 
    const doc = new jsPDF ( );
    doc.autoTable(
     
        
        
        this.exportColumns, this.stands,  {
            
 
            margin: {horizontal: 7},
           
            columnStyles: {0: {columnWidth: '15%'},1: {columnWidth: 100}}
        });
    doc.save('primengTable.pdf');

 
 
  }
  @ViewChild('dt') DataTableVar: Table;
  exportExcel() {

    const doc = new jsPDF('l');
    doc.filename = "cwxc";
    if (this.DataTableVar.filteredValue)
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.getItems(this.DataTableVar.filteredValue));
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "stand_list");
      });
    else import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.getItems(this.stands));
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "stand_list");
    });



  }
  saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
          let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
          let EXCEL_EXTENSION = '.xlsx';
          const data: Blob = new Blob([buffer], {
              type: EXCEL_TYPE
          });
          FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      });
  }

  getStands() {
      let stands = [];
      for(let stand of this.stands) {
          stand.num = stand.num.toString();
          stands.push(stand);
      }
      return stands;
  }
  getItems(items: Stand[]) :Item[]{
    let cars: Item[] = [];

    for (let index = 0; index < items.length; index++) {
      const element = items[index];
      let item = new Item();
      item.Stand = element.num;
      item.Client = element.clientList;
      item.Superficie = element.superficie+" m";
      item.Type = element.standType;
      cars.push(item);
    }




    return cars;
  }
}

class Item {
  Stand: any;
  Client: any;
  Superficie:string;
  Type:string
}